import { ref } from '@vue/composition-api';
import useMutation from '@/compositions/useMutation.js';
import { gql } from '@apollo/client/core';
import Tracking from '@/components/commons/Tracking.js';

export default function useNewsletter() {
  const subscriptionResult = ref({
    message: '',
    success: false,
    sent: false,
  });
  const done = ref(false);

  const {
    mutate: subscribeUserEmail, //
    loading,
    called,
    onError,
    onDone,
  } = useMutation(gql`
    mutation SubscribeEmail($email: String!, $subscriptionSource: String!) {
      subscribeEmail(email: $email, subscriptionSource: $subscriptionSource) {
        success
        message
      }
    }
  `);

  onDone(({ data }) => {
    const { success, message } = data.subscribeEmail;

    subscriptionResult.value = {
      success,
      message,
    };
    done.value = true;
  });

  onError((error) => {
    subscriptionResult.value = {
      message: `Something went wrong. Please, try again later.`,
      success: false,
    };
    done.value = true;
    Tracking.sentryCaptureError(error);
  });

  return {
    subscribeUserEmail,
    subscriptionResult,
    loading,
    called,
    done,
  };
}
